module.exports = __webpack_public_path__ + "static/media/under-construction.651e136f.jpg";